import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../../component/BoostshootRowCard/BoostshootRowCard'
import ServicesInnerCardsCarousel from '../../component/ServicesInnerCardsCarousel/ServicesInnerCardsCarousel'

const cardD = [
  {
    img: false,
    title: "",
    para:'Assessment with a specialized physiotherapist.',
    number:"01",
    id: 1,
  },
  {
    img: false,
    title: "",
    para:'Personalized exercise and therapy plan.',
    number:"02",
    id: 2,
  },
  {
    img: false,
    title: "",
    para:'Progress review and symptom tracking.',
    number:"03",
    id: 3,
  },
]

const cardList = [
  // {
  //    link:"/gyno-uro-clinic",
  //       img:"/images/creatives/service-main-5.webp",
  //   name:"Gyno-Uro Clinic",
  //   rank:"",
  //   para:'Integrated pelvic and urological health care for every stage of life.'
  // },
  {
            link:"/aging-wellness-clinic",
        img:"/images/creatives/service-main-7.webp",
    name:" Aging and Wellness Clinic ",
    rank:"",
    para:'Comprehensive geriatric assessments to support healthy aging.'
  },
]

const boostCardData = [
    "Reduce leakage and improve continence",
    "Ease pelvic pain and discomfort",
    "Support postpartum or surgical recovery",
    "Enhance core and back function",
]

function PelvicFloorTherapy() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
         <Header/>
        <HomeHero
            heading='Pelvic Floor Therapy'
            content='Targeted rehabilitation for pelvic muscle health and function.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/pelvichero-image.png"}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            btnCalnedly={true}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="Formulas for an empowered you"
            para="Our Pelvic Floor Therapy program focuses on strengthening and retraining pelvic muscles to support bladder control, sexual health, and core stability. Delivered by expert physiotherapists with advanced training in pelvic rehab."
            bgImg="/images/creatives/service-main-11.webp"
          />

          <div className='pt-4'></div>
          {/* <SlideScrollContent
            cardData={cardD}
            noContent={true}
          /> */}
          <BoostshootRowCard
            cards={cardD}
          />
          <div className='pb-5'></div>
        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        <div style={{backgroundImage:"url(/images/creatives/boost-shoot-bg.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={boostCardData}
        />

        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph=""
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
        
        </div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default PelvicFloorTherapy